__turbopack_export_value__({
  "body-logo-18": "Promotions-module-scss-module__22NHBa__body-logo-18",
  "body-text-12": "Promotions-module-scss-module__22NHBa__body-text-12",
  "body-text-14": "Promotions-module-scss-module__22NHBa__body-text-14",
  "body-text-16": "Promotions-module-scss-module__22NHBa__body-text-16",
  "body-text-18": "Promotions-module-scss-module__22NHBa__body-text-18",
  "body-text-20": "Promotions-module-scss-module__22NHBa__body-text-20",
  "body-text-24": "Promotions-module-scss-module__22NHBa__body-text-24",
  "body-text-24-2": "Promotions-module-scss-module__22NHBa__body-text-24-2",
  "body-text-heading-2": "Promotions-module-scss-module__22NHBa__body-text-heading-2",
  "body-text-heading-3": "Promotions-module-scss-module__22NHBa__body-text-heading-3",
  "body-text-medium-14": "Promotions-module-scss-module__22NHBa__body-text-medium-14",
  "body-text-medium-16": "Promotions-module-scss-module__22NHBa__body-text-medium-16",
  "body-text-medium-18": "Promotions-module-scss-module__22NHBa__body-text-medium-18",
  "body-text-medium2-18": "Promotions-module-scss-module__22NHBa__body-text-medium2-18",
  "body-text2-14": "Promotions-module-scss-module__22NHBa__body-text2-14",
  "body-text2-16": "Promotions-module-scss-module__22NHBa__body-text2-16",
  "button-primary-text": "Promotions-module-scss-module__22NHBa__button-primary-text",
  "button-text": "Promotions-module-scss-module__22NHBa__button-text",
  "button2-text": "Promotions-module-scss-module__22NHBa__button2-text",
  "card-shadow": "Promotions-module-scss-module__22NHBa__card-shadow",
  "effect-menu": "Promotions-module-scss-module__22NHBa__effect-menu",
  "header-1": "Promotions-module-scss-module__22NHBa__header-1",
  "main-container": "Promotions-module-scss-module__22NHBa__main-container",
  "main-footer-container": "Promotions-module-scss-module__22NHBa__main-footer-container",
  "main-header-container": "Promotions-module-scss-module__22NHBa__main-header-container",
  "promotions": "Promotions-module-scss-module__22NHBa__promotions",
  "promotions__list": "Promotions-module-scss-module__22NHBa__promotions__list",
  "promotions__noResults": "Promotions-module-scss-module__22NHBa__promotions__noResults",
  "promotions__showMore": "Promotions-module-scss-module__22NHBa__promotions__showMore",
  "txt-12-bold": "Promotions-module-scss-module__22NHBa__txt-12-bold",
  "txt-14-bold": "Promotions-module-scss-module__22NHBa__txt-14-bold",
  "txt-14-bold-caps": "Promotions-module-scss-module__22NHBa__txt-14-bold-caps",
  "txt-14-med": "Promotions-module-scss-module__22NHBa__txt-14-med",
  "txt-16-bold": "Promotions-module-scss-module__22NHBa__txt-16-bold",
  "txt-16-med": "Promotions-module-scss-module__22NHBa__txt-16-med",
  "txt-18-bold": "Promotions-module-scss-module__22NHBa__txt-18-bold",
  "txt-18-medium": "Promotions-module-scss-module__22NHBa__txt-18-medium",
  "txt-18-medium-24": "Promotions-module-scss-module__22NHBa__txt-18-medium-24",
  "txt-24-semi": "Promotions-module-scss-module__22NHBa__txt-24-semi",
});
